export default class AnchorLink {
    constructor() {
        this.init();
    }

    init() {
        this.anchorLink();
    }

    anchorLink() {
        // 申し込みのアンカーリンクを特定のエリアで表示・非表示にする
        gsap.fromTo(
            '.js-btn-hidden',
            {
                autoAlpha: 1,
            },
            {
                autoAlpha: 0,
                scrollTrigger: {
                    toggleActions: 'play none none reverse',
                    trigger: '.js-btn-hidden-trigger',
                    start: 'top bottom',
                },
            }
        );


        // 各アンカーリンクを取得、特定のidへ飛ばす
        const anchorElements = document.querySelectorAll('a[href^="#"]');

        if (anchorElements) {
            anchorElements.forEach(anchorElement => {
                anchorElement.addEventListener('click', (e) => {
                e.preventDefault();
                const targetId = anchorElement.getAttribute('href').replace('#', '');
                const target = document.getElementById(targetId).getBoundingClientRect().top + window.pageYOffset;
                window.scrollTo({
                    top: target,
                    behavior: 'smooth'
                });
                });
            });
        }
    }
}
